(ns hai.tasks.routes
  (:require
   [hai.tasks.data :as data]
   [hai.tasks.detail :as detail]
   [hai.tasks.eql :as eql]
   [hai.tasks.page :as page]
   [hai.ui.icons :as icons]
   [hai.ui.rf-sugar :refer [>e]]
   [hai.web-app.routing :as-alias routing]))

(defn routes []
  [["/tasks"
    {:label "Tasks"
     :icon (icons/mui-icon :outlined :task_alt)}
    [""
     {:name :tasks/view
      :view page/page
      ;; This page shows the broad, everything-the-requester-can-see set.
      :controllers [{:start (fn []
                              (>e [::data/load-all-my-tasks]))}]}]
    ["/{task/uuid}"
     {:name :tasks/detail
      ::routing/window-title ::detail/window-title
      :breadcrumbs [:tasks/view "Task"]
      :view detail/page
      :controllers [{:parameters {:path [:task/uuid]}
                     :start (fn [{path :path}]
                              (>e [:entity/resolve path
                                   {;; The same shape every other task host
                                    ;; resolves, so the page and the board agree
                                    ;; on what a task is — tag permissions
                                    ;; included.
                                    :pattern       eql/task-eql
                                    :on-success-fx [[:dispatch [::detail/mark-resolved (:task/uuid path)]]]
                                    :on-error-fx   [[:dispatch [::detail/mark-resolved (:task/uuid path)]]]}]))}]}]]])
